import React from "react";
import { useLocation } from "react-router-dom";
import CTASection from "../CTASection";

function CTAWithLocation(props) {
  const location = useLocation(); // Access the current location

  // Pass all props along with the currentPath to CTASection
  return <CTASection {...props} currentPath={location.pathname} />;
}

export default CTAWithLocation;
